/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    import MultiBlock = Models.MultiBlock;

    /**
     * MultiBlockController class
     */
    export class MultiBlockController {
        public static $name: string = "multiBlockController";
        public static $inject: string[] = [
            'multiBlockService',
            '$q',
            '$window',
            'ModalService',
            'blockService',
        ];

        public multiBlocks: MultiBlock[];

        constructor(private multiBlockService: Services.MultiBlockService,
                    private qService: ng.IQService,
                    private $window: ng.IWindowService,
                    private modalService: ngModal.IModalService,
                    private blockService: Services.BlockService) {
            this.reloadMultiBlocks();
        }

        public launchMultiBlockModal(): void {
            this.blockService.getAllBlocksPromise().then((blocks: Models.IBlock[]) => {
                this.modalService.showModal({
                    templateUrl: Controllers.MultiBlockModalController.templateUrl,
                    controller: Controllers.MultiBlockModalController.$name,
                    inputs: {
                        blocks: blocks,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.MultiBlockModalController.id,
                        { bgclose: false, modal: false, keyboard: false });
                    modalElem.show();
                    modal.close.then((result: {name: string, srcConn: number, dstConn: number}) => {
                        modalElem.hide();
                        if (result) {
                            this.multiBlockService.createMultiBlock({
                                "name": result.name,
                                "origBlockConnectionId": result.srcConn,
                                "destBlockConnectionId": result.dstConn,
                            }).then(() => {
                                this.reloadMultiBlocks();
                            });
                        }
                    });
                });
            });
        }

        public removeMultiBlock(multiBlock: MultiBlock): void {
            if (this.multiBlockService.isMultiBlockConnected(multiBlock)) {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.InfoModalController.templateURL,
                    controller: Application.Controllers.InfoModalController.$name,
                    inputs: {
                        title: 'MULTI BLOCK INFO',
                        description: "This MultiBlock is involved in a pipe connection. Please disconnect its blocks before removing it.",
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID,
                                                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                    });
                });
            } else {
                this.modalService.showModal({
                    templateUrl: Controllers.ConfirmModalController.templateURL,
                    controller: Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'DELETE MULTI BLOCK',
                        description: "This multi block will be deleted and won't be available anymore",
                        name: '',
                        type: 'warning',
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: string) => {
                        modalElem.hide();
                        if (result) {
                            this.multiBlockService.removeMultiBlock(multiBlock).then((response: boolean) => {
                                this.reloadMultiBlocks();
                            });
                        }
                    });
                });
            }
        }

        public getBlockIcon(block: Models.IBlock): string {
                if (block.networkNodeTypeHref === undefined || block.networkNodeTypeHref === '') {
                    return "images/iconmonstr-server-4-240-not-checked.png";
                } else {
                    return `images/nodeTypes/${block.networkNodeTypeHref}.png`;
                }
        }

        private reloadMultiBlocks(): void {
            this.multiBlockService.getAllMultiBlocks().then((multiBlocks: MultiBlock[]) => {
                this.multiBlocks = multiBlocks;
            });
        }

    }
}
